import { routes } from 'utils/routing';

import { navigatorsNameSanitizationMap as baseNavigatorsNameSanitizationMap } from './constants.base';

export const navigatorsNameSanitizationMap = {
  ...baseNavigatorsNameSanitizationMap,
  [routes.rewardsList]: routes.loyaltyRewardsList,
};
